import calendarIcon from "../../assets/all-icons/briefcase-blue.png";
import employmentIcon from "../../assets/all-icons/briefcase-green.png";
import incomeIcon from "../../assets/all-icons/database-purple.png";
import documentsIcon from "../../assets/all-icons/layers-orange.png";
import { useInView } from "../../hooks/useInView";

const REQUIREMENTS = [
  {
    icon: calendarIcon,
    cardBg: "#eff6ff",
    label: "Age",
    value: "22–55 years",
    description:
      "Open to young professionals and salaried applicants across this age bracket.",
  },
  {
    icon: employmentIcon,
    cardBg: "#f0fdf4",
    label: "Employment",
    value: "Salaried Professional",
    description:
      "We currently support applicants with a steady, verifiable monthly salary structure.",
  },
  {
    icon: incomeIcon,
    cardBg: "#f3eeff",
    label: "Monthly Income",
    value: "₹50,000+ net",
    description:
      "Your net monthly in-hand income should be ₹50,000 or higher to qualify.",
  },
  {
    icon: documentsIcon,
    cardBg: "#fff7ed",
    label: "Documents",
    value: "KYC + Bank Statement",
    description:
      "Keep your PAN, Aadhaar, and latest 3 months bank statements ready for auto-upload.",
  },
];

export function Eligibility() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="w-full bg-white px-4 py-16 sm:py-20">
      <div
        ref={ref}
        className={`mx-auto flex w-full max-w-[800px] flex-col items-center gap-3 text-center ${inView ? "in-view" : ""}`}
      >
        <span className="reveal-scroll delay-1 rounded-full bg-[#e6f4f2] px-4 py-[6px] text-xs font-semibold uppercase tracking-[0.6px] text-brand-teal">
          Eligibility Criteria
        </span>
        <h2 className="reveal-scroll delay-2 text-3xl font-extrabold leading-tight text-brand-purple sm:text-4xl">
          Check your Eligibility
        </h2>
        <p className="reveal-scroll delay-3 max-w-[560px] text-base leading-6 text-[#475569]">
          See the four key requirements to apply in minutes. We've kept the
          process simple, flexible, and transparent.
        </p>
      </div>

      <div className="mx-auto mt-10 grid w-full max-w-[1280px] grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {REQUIREMENTS.map((req) => (
          <div
            key={req.label}
            className="flex flex-col rounded-[20px] p-6"
            style={{ backgroundColor: req.cardBg }}
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)]">
              <img src={req.icon} alt="" className="h-5 w-5" />
            </span>
            <p className="pt-4 text-sm text-[#475569]">{req.label}</p>
            <p className="pt-[2px] text-xl font-bold leading-6 text-[#1c1917]">
              {req.value}
            </p>
            <p className="pt-2 text-[13px] leading-5 text-[#64748b]">
              {req.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
